import styled from 'styled-components';
import Link from 'next/link';

import { APP_DOWNLOAD_LINK_APP_PAGE } from '../enums/appLandingPageEnums';

export const IosCta = () => (
  <Link href={APP_DOWNLOAD_LINK_APP_PAGE}>
    <a aria-label="Download the GOAT App">
      <IosCta.Img src="/images/apple-app-store-cta.png" alt="App Store CTA" />
    </a>
  </Link>
);

IosCta.Img = styled.img`
  height: 40px;
  border: 1px solid;
  border-radius: 5px;
`;
